import React from 'react'

const ScreenLoader = ({
  isLoadingScreen,
  onModal = false,
}: {
  isLoadingScreen: boolean
  onModal?: boolean
}) => {
  return (
    <>
      <span
        className={` ${isLoadingScreen ? '' : 'hidden'} fixed inset-0  ${onModal ? '' : 'z-[51] '} !bg-black !opacity-[0.09] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0`}
      ></span>
      <span
        className={`${isLoadingScreen ? '' : 'hidden'} fixed left-[50%] top-[50%] z-[52] w-full  translate-x-[-50%] translate-y-[-50%] duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] flex justify-center`}
      >
        <span className="form-loader"></span>
      </span>
    </>
  )
}

export default ScreenLoader
